export default __webpack_public_path__ + "5689819d85055ad86d96980040303f54.png";